import { createReducer, on } from '@ngrx/store';

import {
    SetActiveTransformationsByType,
    SetChainDisplayNames,
    SetInboundDetailedTransformations,
    SetIntegrationsChains,
    SetMasterSchedulerTransformations,
    SetOutboundChains,
    SetTransformationAndChains,
    SetTransformationNamesInChain,
    SetTransformations,
    SetTransformationsLoading,
    SetTransformationsRelativeOrganizations,
    SetUpdatedTransformations,
} from '../actions';
import * as sessionActions from '../actions/session.actions';
import { transformationsState } from '../states';

export const TRANSFORMATIONS_REDUCER_KEY = 'transformations';

export const TRANSFORMATIONS_REDUCER = createReducer(
    transformationsState,
    on(SetInboundDetailedTransformations, (state, action) => {
        const { inbound: inBoundTransformations, restApiName, organizationId, relativeOrganizations } = action;
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [organizationId]: {
                    ...state.organizationsMap?.[organizationId],
                    services: {
                        ...state.organizationsMap?.[organizationId]?.services,
                        [restApiName]: {
                            ...state.organizationsMap?.[organizationId]?.services?.[restApiName],
                            relativeOrganizations: {
                                ...relativeOrganizations,
                            },
                            transformations: {
                                ...state.organizationsMap?.[organizationId]?.services?.[restApiName]?.transformations,
                                inboundDetailed: inBoundTransformations,
                            },
                        },
                    },
                },
            },
        };
    }),
    on(SetUpdatedTransformations, (state, action) => {
        const { inbound: inBoundTransformations, restApiName, organizationId, relativeOrganizations } = action;
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [organizationId]: {
                    ...state.organizationsMap?.[organizationId],
                    services: {
                        ...state.organizationsMap?.[organizationId]?.services,
                        [restApiName]: {
                            ...state.organizationsMap?.[organizationId]?.services?.[restApiName],
                            relativeOrganizations: {
                                ...relativeOrganizations,
                            },
                            transformations: {
                                ...state.organizationsMap?.[organizationId]?.services?.[restApiName]?.transformations,
                                inboundDetailed: inBoundTransformations,
                            },
                        },
                    },
                },
            },
        };
    }),
    on(SetTransformationsRelativeOrganizations, (state, action) => {
        const { restApiName, organizationId, relativeOrganizations } = action;
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [organizationId]: {
                    ...state.organizationsMap?.[organizationId],
                    services: {
                        ...state.organizationsMap?.[organizationId]?.services,
                        [restApiName]: {
                            ...state.organizationsMap?.[organizationId]?.services?.[restApiName],
                            relativeOrganizations: {
                                ...relativeOrganizations,
                            },
                        },
                    },
                },
            },
        };
    }),
    on(SetChainDisplayNames, (state, { restApiName, chainVsDisplaynames, organizationId }) => {
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [organizationId]: {
                    ...state.organizationsMap?.[organizationId],
                    services: {
                        ...state.organizationsMap?.[organizationId]?.services,
                        [restApiName]: {
                            ...state.organizationsMap?.[organizationId]?.services?.[restApiName],
                            chainDisplayNames: chainVsDisplaynames,
                        },
                    },
                },
            },
        };
    }),
    on(SetTransformationsLoading, (state, action) => {
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [action.organizationId]: {
                    ...state.organizationsMap?.[action.organizationId],
                    services: {
                        ...state.organizationsMap?.[action.organizationId]?.services,
                        [action.restApiName]: {
                            ...state.organizationsMap?.[action.organizationId]?.services?.[action.restApiName],
                            loading: {
                                ...state.organizationsMap?.[action.organizationId]?.services?.[action.restApiName]?.loading,
                                [action.category]: action.loading,
                            },
                        },
                    },
                },
            },
        };
    }),
    on(SetTransformations, (state, action) => {
        const { restApiName, transformations, organizationId } = action;
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [organizationId]: {
                    ...state.organizationsMap?.[organizationId],
                    services: {
                        ...state.organizationsMap?.[organizationId]?.services,
                        [restApiName]: {
                            ...state.organizationsMap?.[organizationId]?.services?.[restApiName],
                            transformations: {
                                ...state.organizationsMap?.[organizationId]?.services?.[restApiName]?.transformations,
                                inbound: transformations?.['INBOUND'],
                                outbound: transformations?.['OUTBOUND'],
                            },
                        },
                    },
                },
            },
        };
    }),
    on(SetActiveTransformationsByType, (state, action) => {
        const { restApiName, organizationId, transformationNames, transformationType } = action;
        let inboundActiveTransformations: string[];
        let outboundActiveTransformations: string[];

        if (transformationType === 'INBOUND') {
            inboundActiveTransformations = transformationNames;
            outboundActiveTransformations =
                state.organizationsMap?.[organizationId]?.services?.[restApiName]?.transformations?.activeTransformations?.outbound;
        } else {
            inboundActiveTransformations =
                state.organizationsMap?.[organizationId]?.services?.[restApiName]?.transformations?.activeTransformations?.inbound;
            outboundActiveTransformations = transformationNames;
        }
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [organizationId]: {
                    ...state.organizationsMap?.[organizationId],
                    services: {
                        ...state.organizationsMap?.[organizationId]?.services,
                        [restApiName]: {
                            ...state.organizationsMap?.[organizationId]?.services?.[restApiName],
                            transformations: {
                                ...state.organizationsMap?.[organizationId]?.services?.[restApiName]?.transformations,
                                activeTransformations: {
                                    ...state.organizationsMap?.[organizationId]?.services?.[restApiName]?.transformations
                                        ?.activeTransformations,
                                    inbound: inboundActiveTransformations,
                                    outbound: outboundActiveTransformations,
                                },
                            },
                        },
                    },
                },
            },
        };
    }),
    on(SetMasterSchedulerTransformations, (state, action) => {
        const { restApiName, organizationId, transformations } = action;
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [organizationId]: {
                    ...state.organizationsMap?.[organizationId],
                    services: {
                        ...state.organizationsMap?.[organizationId]?.services,
                        [restApiName]: {
                            ...state.organizationsMap?.[organizationId]?.services?.[restApiName],
                            transformations: {
                                ...state.organizationsMap?.[organizationId]?.services?.[restApiName]?.transformations,
                                masterScheduler: {
                                    ...state.organizationsMap?.[organizationId]?.services?.[restApiName]?.transformations?.masterScheduler,
                                    inbound: transformations?.INBOUND,
                                    outbound: transformations?.OUTBOUND,
                                },
                            },
                        },
                    },
                },
            },
        };
    }),
    on(SetIntegrationsChains, (state, action) => {
        const { restApiName, organizationId, chains } = action;
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [organizationId]: {
                    ...state.organizationsMap?.[organizationId],
                    services: {
                        ...state.organizationsMap?.[organizationId]?.services,
                        [restApiName]: {
                            ...state.organizationsMap?.[organizationId]?.services?.[restApiName],
                            transformations: {
                                ...state.organizationsMap?.[organizationId]?.services?.[restApiName]?.transformations,
                                integrationsChains: {
                                    ...state.organizationsMap?.[organizationId]?.services?.[restApiName]?.transformations
                                        ?.integrationsChains,
                                    inbound: chains?.INBOUND,
                                    outbound: chains?.OUTBOUND,
                                },
                            },
                        },
                    },
                },
            },
        };
    }),
    on(SetOutboundChains, (state, action) => {
        const { restApiName, organizationId, chains } = action;
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [organizationId]: {
                    ...state.organizationsMap?.[organizationId],
                    services: {
                        ...state.organizationsMap?.[organizationId]?.services,
                        [restApiName]: {
                            ...state.organizationsMap?.[organizationId]?.services?.[restApiName],
                            transformations: {
                                ...state.organizationsMap?.[organizationId]?.services?.[restApiName]?.transformations,
                                chains: chains,
                            },
                        },
                    },
                },
            },
        };
    }),
    on(SetTransformationNamesInChain, (state, action) => {
        const { organizationId, restApiName, chainName, transformations } = action;
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [organizationId]: {
                    ...state.organizationsMap?.[organizationId],
                    services: {
                        ...state.organizationsMap?.[organizationId]?.services,
                        [restApiName]: {
                            ...state.organizationsMap?.[organizationId]?.services?.[restApiName],
                            transformationsByChainName: {
                                ...state.organizationsMap[organizationId]?.services?.[restApiName].transformationsByChainName,
                                [chainName]: transformations,
                            },
                        },
                    },
                },
            },
        };
    }),

    on(SetTransformationAndChains, (state, action) => {
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [action.organizationId]: {
                    ...state.organizationsMap?.[action.organizationId],
                    services: {
                        ...state.organizationsMap?.[action.organizationId]?.services,
                        [action.restApiName]: {
                            ...state.organizationsMap?.[action.organizationId]?.services?.[action.restApiName],
                            transformations: {
                                ...state.organizationsMap?.[action.organizationId]?.services?.[action.restApiName]?.transformations,
                                chainsAndTransformations: {
                                    ...state.organizationsMap?.[action.organizationId]?.services?.[action.restApiName]?.transformations
                                        ?.chainsAndTransformations,
                                    ...action.chains,
                                },
                            },
                        },
                    },
                },
            },
        };
    }),

    on(sessionActions.SessionLogoutSuccessfull, () => {
        return transformationsState;
    })
);
